<div>
  <div *ngIf="!showNoResultsFound" class="comparative-search-menu-container">
    <ul class="comparative-menu-list">
      <li
        *ngFor="let item of menuList"
        (click)="handleMenuItemClick(item, $event)"
        (mouseenter)="handleMenuItemMouseEnter(item, $event)"
        (mouseleave)="handleMenuItemMouseLeave(item, $event)"
        class="comparative-menu-list-item"
        [ngClass]="{
          selected: activatedOptions === item.id,
          disabled: (!item.isLeaf && !menuSearchCount[item.id]) || item.disabled
        }"
      >
        <span>{{ item.label }}</span>
        <div class="display-flex flex-align-center" *ngIf="!item.isLeaf">
          <!-- <span *ngIf="searchedTerm"> {{ menuSearchCount[item.id] }}</span> -->
          <div class="arrow-icon">
            <va-icon size="small" name="chevron-right"></va-icon>
          </div>
        </div>
      </li>
    </ul>

    <div class="comparative-menu-right-section" [ngSwitch]="activatedOptions">
      <div *ngSwitchCase="'industry'">
        <app-industry-menu
          [data]="industryMenuData"
          [searchedValue]="searchedTerm"
          [isLoading]="isIndustryMenuApiInProgress"
          [isMcapGeoDataLoading]="isMarketGeoApiInProgress"
          [marketCapData]="marketCapData"
          [selectedMarketCaps]="selectedMarketCapsId"
          [selectedCountires]="selectedCountriesId"
          [selectedRegions]="selectedRegionsId"
          [geographyData]="geographyData"
          [otherGeoLen]="otherGeoLen"
          [selectedIndustryData]="selectedIndustryData"
          (onCancelButtonClick)="handleIndustryMenuCancelButtonClick()"
          (onApplyButtonClick)="handleIndustryMenuApplyButtonClick($event)"
        ></app-industry-menu>
      </div>
      <div *ngSwitchCase="'comp_table'">
        <app-system-menu
          [data]="compTableMenuData"
          [searchedValue]="searchedTerm"
          [isLoading]="isCompMenuApiInProgress"
          [selectedSystemData]="selectedSystemData"
          (onItemClick)="handlSystemItemClick($event)"
        ></app-system-menu>
      </div>
      <div *ngSwitchCase="'custom_analysis'">
        <app-menu-list
          [data]="customAnalysisMenuData"
          [selectedMenuId]="selectedCustomAnalysisId"
          [searchedValue]="searchedTerm"
          [isLoading]="isCustomMenuApiInProgress"
          (onListClick)="handleCustomItemClick($event)"
        ></app-menu-list>
      </div>
      <div *ngSwitchCase="'watchlist'">
        <app-watchlist-search-menu
          [data]="watchlistMenuData"
          [searchedValue]="searchedTerm"
          [isLoading]="isWatchlistMenuApiInProgress"
          [isMcapGeoDataLoading]="isMarketGeoApiInProgress"
          [marketCapData]="marketCapData"
          [selectedMarketCaps]="selectedMarketCapsId"
          [selectedCountires]="selectedCountriesId"
          [selectedRegions]="selectedRegionsId"
          [geographyData]="geographyData"
          [otherGeoLen]="otherGeoLen"
          [watchlistId]="selectedWatchlistId"
          (onCancelButtonClick)="handleWatchlistMenuCancelButtonClick()"
          (onApplyButtonClick)="handleWatchlistMenuApplyButtonClick($event)"
        ></app-watchlist-search-menu>
      </div>
    </div>
  </div>

  <div *ngIf="showNoResultsFound" class="no-results">
    No results for "{{ searchedTerm }}"
  </div>
</div>
